import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";

import { ENABLED_LANGUAGES } from "./languages";

const allResources: Record<string, { translation: Record<string, unknown> }> = {
  en: { translation: en },
  zh: { translation: zh },
  es: { translation: es },
  ar: { translation: ar },
  hi: { translation: hi },
};

const resources: typeof allResources = {};
ENABLED_LANGUAGES.forEach((lang) => {
  if (allResources[lang.code]) resources[lang.code] = allResources[lang.code];
});
if (!resources["en"]) resources["en"] = allResources["en"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "armf_language",
    },
  });

export default i18n;
